import { mapSortFieldToSegmentEvent } from '../constants';
import { TSegmentTrackPayload } from '../../../../../middlewares/segment/trackEntities/types';
import { ESortField } from '../../../../../store/model/list/types';

export const getSegmentEventForSortField = (
    sortField: ESortField
): TSegmentTrackPayload => {
    return mapSortFieldToSegmentEvent[sortField]
};
